module.exports = __webpack_public_path__ + "img/black-mag.2c5e360.svg";